import store from "@store/index";
import i18n from "@i18n/i18n";
import { Platform, Share } from "react-native";
import * as Linking from "expo-linking";
import { showPopupMessage, showScanner, showSnackbar } from "@store/actions/global";
import { setSelectedNFT } from "@store/actions/nfts.action";
import { setSelectedPost } from "@store/actions/social.actions";
import NFTService from "./NFTService";
import SocialNetworkService from "@screens/social/service/SocialNetworkService";
import { NavigationType } from "@custom-types/NavigationType";
import ExperienceService from "./ExperienceService";
import { claimAsset, claimMembership, getAsset, getMembership, isExperience } from "@screens/scanner/implementations/ExperiencesImplementation";
import { TabsNavigatorScreens } from "@navigation/TabsNavigator";
import { ExperienceModuleType, ModuleControlService } from "./ModuleControlService";

const { t } = i18n;

export default class ShareService {
    private static instance: ShareService;
    isLinkingInit: boolean = false;

    constructor() { }

    static getInstance(): ShareService {
        if (!ShareService.instance) {
            ShareService.instance = new ShareService();
        }
        return ShareService.instance;
    }

    handleLinking = (navigation: NavigationType) => {
        if (!this.isLinkingInit) {
            this.isLinkingInit = true;

            // App closed
            if (Platform.OS == "android") {
                const NativeIntent = require("react-native/Libraries/Linking/NativeIntentAndroid").default;

                NativeIntent.getInitialURL().then((url) => {
                    const { queryParams } = Linking.parse(url);
                    this.redirectLinking(queryParams, navigation);
                });
            } else {
                Linking.parseInitialURLAsync().then((url) => {
                    const { queryParams } = url;
                    this.redirectLinking(queryParams, navigation);
                });
            }

            // App in the background
            if (Platform.OS != "web")
                Linking.addEventListener("url", ({ url }) => {
                    const { queryParams } = Linking.parse(url);
                    this.redirectLinking(queryParams, navigation);
                });
        }
    };

    redirectLinking = async (queryParams: any, navigation) => {
        if (queryParams?.id) {
            switch (queryParams?.type) {
                case "nft":
                    const updatedNft = await NFTService.getInstance().getNFT(queryParams?.id, queryParams?.blockchain, true);
                    store.dispatch(setSelectedNFT(updatedNft));
                    navigation.navigate("NFTs");
                    navigation.navigate("NFTs", {
                        screen: "NFT",
                    });
                    break;

                case "post":
                    const updatedPost = await SocialNetworkService.getInstance().getPostById(queryParams?.id);
                    store.dispatch(setSelectedPost(updatedPost));
                    navigation.navigate("SocialNetwork");
                    navigation.navigate("SocialNetwork", {
                        screen: "PostDetail",
                    });
                    break;

                case "experience":
                    const experience = await ExperienceService.getInstance().getExperience(queryParams?.id);
                    navigation.navigate("Experience", {
                        screen: "ExperienceDetail",
                        params: { experience },
                    });
                    break;

                case "profile":
                    navigation.navigate("Profile", {
                        screen: "ProfileMain",
                        params: { clientID: queryParams?.id },
                    });
                    break;

                case "asset":
                    getAsset(navigation, queryParams?.id)
                    break;

                case "asset.option":
                    claimAsset(navigation, queryParams?.id)

                    break;

                case "membership":
                    getMembership(navigation, queryParams?.id)
                    break;

                case "membership.option":
                    claimMembership(navigation, queryParams?.id)
                    break;

                default:
                    store.dispatch(showScanner());
                    break;
            }
        }
    };

    handleShare = async (message: string, redirectLink: string) => {
        if (Platform.OS == "web") {
            navigator.clipboard.writeText(`${message} ${redirectLink}`);
            store.dispatch(showSnackbar({ type: "SUCCESS", message: t("link_copied") }));
        } else {
            try {
                await Share.share({
                    message: `${message} ${redirectLink} `,
                    url: redirectLink,
                });
            } catch (error: any) {
                store.dispatch(
                    showSnackbar({
                        type: "ERROR",
                        message: error.message,
                    })
                );
            }
        }
    };
}
